var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bal_row"},[_c('p',{staticClass:"symbol"},[_vm._v(_vm._s(_vm.symbol))]),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('p',{staticClass:"amt"},[_vm._v(_vm._s(_vm.asset.toString()))])])}
var staticRenderFns = []

export { render, staticRenderFns }